import { SalesOrderReportLineProcessing } from './sales-order-report-line-processing';

export interface SalesOrderProformaReportLine {
  productKey: string;
  productDescription: string;
  makeUp: string;
  customerProduct: string;
  commodityCode: string;
  origin: string;
  quantity: number;
  unit: number;
  price: number;
  discountedPrice: number;
  priceListUnit: string;
  discount: number;
  value: number;
  currencySymbol: string;
  customerLineRef: string;

  salesOrderLineProcessings: SalesOrderReportLineProcessing[];
}
